import * as React from 'react';

const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
        >
            <path d="M9 1.8v14.4M1.8 9h14.4" />
        </g>
    </svg>
);
export default PlusIcon;
